import React from "react";
import { Box, IconButton, Link, Typography } from "@mui/material";
import logo from "../Assets/natureall-nb.png"; // Adjust the path as necessary
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

const WaveFooter = () => {
  return (
    <Box
      sx={{
        position: "relative",
        height: "160px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        background: "#b7e4c7",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Footer Logo"
        sx={{
          position: "absolute",
          top: { xs: 60, md: 60 },
          left: { xs: 0, md: 24 },
          height: { xs: 50, md: 100 },
          zIndex: 2,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 5, // Position at the bottom
          right: 20, // Position at the right
          zIndex: 2,
          display: "flex",
          flexDirection: "column", // Stack vertically
          alignItems: "flex-end",
          top: { xs: 60, md: 110 },
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton size="small" sx={{ color: "#009748" }}>
            <EmailIcon fontSize="small" />
          </IconButton>
          <Link
            href="mailto:sales@natureall.co.za"
            underline="none"
            color="#2d6a4f"
            sx={{
              "&:hover": { color: "gray" },
              fontSize: { xs: "0.6rem", md: "1rem" },
            }}
          >
            sales@natureall.co.za
          </Link>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          gap={1}
          mt={{ xs: -1, md: 0 }}
        ></Box>
      </Box>
      {/* </Box> */}
      {/* Centered Text */}
      <Typography
        variant="body2"
        sx={{
          position: "absolute",
          bottom: 2,
          zIndex: 1,
          color: "#2d6a4f",
          textAlign: "center",
          fontSize: { xs: "0.5rem", md: "0.9rem" },
        }}
      >
        @2025 Natureall. All rights reserved.
      </Typography>
      {/* SVG Wave (flipped upward) */}
      <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 240"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          transform: "scaleY(-1)",
          // <-- flips the wave upward
        }}
      >
        <path
          fill="#ffffff"
          d="M0,224L48,213.3C96,203,192,181,288,170.7C384,160,480,160,576,176C672,192,768,200,845,200.3C955,203,1056,155,1140,155C1270,135,1360,220,1480,210.7L1445,128L1440,320L0,320Z"
        />
      </Box>
    </Box>
  );
};

export default WaveFooter;
